import styled from 'styled-components'

const StyledFooter = styled.div`
  margin-top: auto;
  margin-left: -46px;
  padding: 18px 44px;
  font-size: 12px;
  font-family: 'Roboto', Arial, sans-serif;
  background-color: var(--color-bg-footer);
  text-transform: capitalize;
  color: var(--color-text-primary);
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  display: flex;

  & > *:not(:last-child) {
    margin-right: 10px;
  }

  @media only screen and (max-width: 920px) {
    margin-left: 0;
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;

    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 4px;
    }

    & > *:last-child {
      margin-left: initial !important;
    }
  }
`

const PrivacyPolicy = styled.a`
  color: var(--color-secondary);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--color-primary);
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid var(--color-focus);
    outline-offset: 2px;
  }
`

const Footer = () => {
  return (
    <StyledFooter>
      <p>
        <PrivacyPolicy href="https://www.caylent.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</PrivacyPolicy>
      </p>
      <p style={{ marginLeft: 'auto' }}>
        Copyright &copy; {new Date().getFullYear()} Caylent
      </p>
    </StyledFooter>
  )
}

export default Footer
